import { AuthPage } from '../../components/pages/auth';

export const ResetPassword = () => {
  return <AuthPage type='resetPassword' />;
};
